import { Injectable, OnInit } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { Store } from "@ngrx/store";
import { CookieService } from "ngx-cookie-service";
import { Subscription, tap } from "rxjs";
import {  fetch_cart, update_cart, add_to_cart, request_cart_total, remove_from_cart } from "./constants/cart.constant";
import { CartService } from "../../Services/cart.services";
import { FETCH_CART_ACTION, HasError, RECALCULATE_CART_TOTAL_ACTION, SET_CART_ACTION } from "./cart.action";
import { CartFacade } from "../facades";
import { LanguageService } from "imakeapp-shared";




@Injectable()
export class CartEffect implements OnInit
{


  lang =  'en';



  constructor(
    private store:Store,
    private actions$: Actions,
    private service:CartService,
    private cartFacades:CartFacade,
    private language_s: LanguageService,
    private cookie_s: CookieService
  ) {}




  ngOnInit(): void
  {


    ;

  }



  remove_from_cart_effect$ = createEffect(
    () => {

      return this.actions$.pipe(
            ofType(remove_from_cart),
            tap(
              (action:any)=>{


                let variables = {

                  id: action.data
                };

                this.service.delete_cart(variables).subscribe(
                  (response: any)=>{

                    this.cartFacades.requestCartTotal()

                  },
                  (err)=>{
this.store.dispatch(new HasError(err.message))

                  }
                );

              }
            )
          )
  },{dispatch:false});




  request_cart_total_effect$ = createEffect(
    () => {

      return this.actions$.pipe(
            ofType(request_cart_total),
          tap(
              (action:any)=>{

                let cart_code = this.cookie_s.get('cart_code');
                let user_id = this.cookie_s.get('user') ? JSON.parse(this.cookie_s.get('user')).user.id : null;
                // get cart data
                let body = {
                  code: cart_code,
                  user_id: user_id
                };
                this.service.get_cart_total(body).subscribe(
                  (response: any)=>{
                //     // save cart total
                console.log(response)
                     this.store.dispatch(new RECALCULATE_CART_TOTAL_ACTION(response));
                  },
                  (err)=>{
                    console.log(err)
                    this.store.dispatch(new RECALCULATE_CART_TOTAL_ACTION(0));
                    this.store.dispatch(new HasError(err.message))

                  }
                 );

              }
            )
          )
  },{dispatch:false});







  update_cart_effect$ = createEffect(
    () => {

      return this.actions$.pipe(
            ofType(update_cart),
            tap(
              (action:any)=>{

                let cart_code = this.cookie_s.get('cart_code');
                let user_id = this.cookie_s.get('user') ? JSON.parse(this.cookie_s.get('user')).user.id : null;

                let variables = {
                  code: cart_code,
                  user_id: user_id,
                  id: action.data.cart_id,
                  amount: +action.data.new_amount
                };

                this.service.update_cart(variables).subscribe(
                  (response: any)=>{

                   this.cartFacades.requestCartTotal()


                  },
                  (err)=>{
                    this.store.dispatch(new HasError(err.message))
                  }
                );

              }
            )
          )
  },{dispatch:false});


  add_to_cart_effect$ = createEffect(
    () => {

      return this.actions$.pipe(
            ofType(add_to_cart),
            tap(
              (action:any)=>{



                this.service.add_to_cart(action.data).subscribe(
                  (response: any)=>{

                    // fetch cart
                    console.log(response)
                    this.cartFacades.RequestCart()

                  },
                  (err)=>{
                    this.store.dispatch(new HasError(err.message))
                  }
                );
              }
            )
          )
  },{dispatch:false});
  fetch_cart_effect$ = createEffect(
    () => {

      return this.actions$.pipe(
        ofType(fetch_cart),
        tap(
          (action:any)=>{

            let cart_code = this.cookie_s.get('cart_code');
            let user_id = this.cookie_s.get('user') ? JSON.parse(this.cookie_s.get('user')).user.id : -1;

            let variables = {
              code: cart_code,
              user_id: user_id
            };

            this.service.get_cart(variables).subscribe(
              (response: any)=>{


                this.store.dispatch(new SET_CART_ACTION(response.data.carts));

              },
              (err)=>{
                this.store.dispatch(new HasError(err.message))
              }
            );

          }
        )
      )
  },{dispatch:false});
}


